import React from "react";
import { usePWA } from "hooks/usePWA";

const OfflineTopBarNotification: React.FC = () => {
  const { isOffline } = usePWA();

  if (!isOffline) return null;

  return (
    <div>
      <div
        style={{
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "#f44336",
          color: "white",
          padding: "10px",
          textAlign: "center",
          zIndex: 9999,
        }}
      >
        Jesteś w trybie offline
      </div>
    </div>
  );
};

export default OfflineTopBarNotification;
